import get from 'lodash/get';
import * as TYPES from '../../constants/actionTypes';

const intialState = {
  roles: [],
};

const ConfigReducer = (state = intialState, action = {}) => {
  switch (action.type) {
    case TYPES.UPDATE_ROLES:
      return {
        ...state,
        roles: get(action, 'payload'),
      };

    default:
      return state;
  }
};
export default ConfigReducer;
